module.exports = __webpack_public_path__ + "static/media/logo_validated.0c818946.png";